import * as React from 'react';
import { FixMeLater } from '../../utils';
import { TypographyBody, TypographyBodyProps } from '../Typography';
import { PriceBlockContext } from './PriceBlockContext';

export type PriceBlockLegendProps = TypographyBodyProps;

export const PriceBlockLegend: React.ForwardRefExoticComponent<
    PriceBlockLegendProps & React.RefAttributes<HTMLElement>
> = React.forwardRef(function PriceBlockLegend(
    props: PriceBlockLegendProps,
    ref: React.ForwardedRef<FixMeLater>
): React.JSX.Element {
    const { align } = React.useContext(PriceBlockContext);
    return <TypographyBody ref={ref} size="xs" component="div" ta={align} {...props} />;
});
